import { extend } from 'umi-request';

const request = extend({
  prefix: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_URL : '/api',

  // credentials: 'include', // 允许携带 cookies
});

export const chatApi = {
  createQa: (data: any) => request.post('/chat/qa/create', {
    data,
  }),
  queryQa: (params: any) => request.get('/chat/qas', {
    params: params,
  }),

  queryCs: (params: any) => request.get('/knowledge-base/cs/fetch', { params }),
  
  createCs: (data: any) => request.post('/knowledge-base/cs/create', { data }),

  // 获取AI回答
  getAiAnswer: (params: any) => request.post('/chat/ai/answer', { data: params }),

  // 上传图片
  uploadImage: (formData: FormData) => request.post('/chat/upload/image', {
    data: formData,
  }),

  // 上传视频
  uploadVideo: (formData: FormData) => request.post('/chat/upload/video', {
    data: formData,
  }),

  // 聊天记忆相关接口
  // 获取聊天记忆列表
  listMemory: (params: any) => request.get('/chat/memory/list', {
    params,
  }),

  // 创建聊天记忆
  createMemory: (data: any) => request.post('/chat/memory/create', {
    data,
  }),

  // 获取记忆回答
  getMemoryAnswer: (data: any) => request.post('/chat/memory/answer', {
    data,
  }),

  // 关闭聊天会话
  closeChat: (data: any) => request.post('/chat/close', {
    data,
  }),

  // 评分接口
  rateMemory: (data: any) => request.post('/chat/memory/rate', {
    data,
  }),

  // 快捷回复接口
  quickAnswer: (data: any) => request.post('/chat/memory/quickAnswer', {
    data,
  }),

  // 获取快捷问题列表
  fetchQuickQuestion: (code: string) => request.get('/robot/quickQa/fetch/' + code),
  
  // 提交聊天评价
  submitEvaluation: (data: {
    token?: string;
    csUuid?: string;
    rating: number;
    feedback?: string;
  }) => request.post('/chat/evaluation/submit', {
    data,
  }),

  // 分类回复
  categoryAnswer: (token?: string, csUuid?: string, category?: string) => request.post('/chat/memory/categoryAnswer', {
    data: { token, csUuid, category },
  }),

  categoryAnswerV2: (token?: string, csUuid?: string, category?: string) => request.post('/chat/memory/categoryAnswerV2', {
    data: { token, csUuid, category },
  }),

  questionTreeAnswer: (data: {
    token?: string;
    csUuid?: string;
    category?: string;
    questionLeafId: string;
  }) => request.post('/chat/memory/questionTreeAnswer', { data }),

  // 更新聊天评价
  updateEvaluation: (data: {
    uuid?: string;
    rating: number;
    feedback?: string;
  }) => request.post('/chat/evaluation/update', {
    data,
  }),
};


export const createToken = (code: string, token: string, uid?: string, isReCreate?: boolean, category?: string, username?: string, superAdminUid?: string) => 
  request.post('/chat/token', {data: { code, token, uid, isReCreate, category, username, superAdminUid }});

// 使用token创建对话会话
export const createChatSession = (token: string, code?: string, uid?: string, username?: string, superAdminUid?: string) =>   
  request.post('/chat/token', {data: { token, code, uid, username, superAdminUid }});

export const fetchRobot = (code: string) => 
  request.get('/chat/robot/'+ code);

// 获取设置
export const fetchSetting = (code: string) => 
  request.get('/robot/setting/fetch/'+ code);

export const traceApi = {
  // trace/to-confirm-page
  toConfirmPage: (data: any) => request.get('/trace/to-confirm-page', {
    params: data,
  }),
  // trace/in-conversation
  inConversation: (data: any) => request.get('/trace/in-conversation', {
    params: data,
  }),
}

export const commonApi = {
    // 上传图片
    uploadImage: (formData: FormData) => request.post('/common/upload/image', {
      data: formData,
    }),
  
    // 上传视频
    uploadVideo: (formData: FormData) => request.post('/common/upload/video', {
      data: formData,
    }),

    // 上传文件
    uploadFile: (formData: FormData) => request.post('/common/upload/file', {
      data: formData,
    }),
}

export const uchatApi = {
  // 获取所有聊天中的会话
  chattingList: (code: string, uid: string) => request.get('/uchat/cs/chatting', {
    params: { code, uid },
  }),

  // 创建聊天会话
  createCs: (data: any) => request.post('/uchat/cs/create', {
    data,
  }),

  // 查询聊天会话
  queryCs: (csUuid: string) => request.get('/uchat/cs/fetch', { params: { csUuid } }),

  // 查询玩家未读数
  unread: (code: string, uid: string) => request.get('/uchat/cs/unread', {
    params: { code, uid },
  }),

  // 标记玩家消息已读
  markRead: (data: { code: string; uid: string; csUuid?: string }) =>
    request.post('/uchat/cs/mark-read', { data }),
}